import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "position-history-force-edit",
  components: {
    AppHeader
  },
  async created() {
    await this.getUser();
    this.getPosition();
    await this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      positionHistories: [
        {
          year: "",
          month: "",
          day: "",
          user_id: this.$route.params.user_id,
          position_id_before: "",
          position_name_before: "",
          position_id_after: "",
          position_name_after: ""
        }
      ],
      positions: "",
      getPositionsEnd: false,
      errorInfo: "",
      user: "",
      savingFlag: false
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getPosition() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positions = res.positions;
      this.getPositionsEnd = true;
    },
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
    },
    async forceChangePositionHistory() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      let latestDate = "0000-00-00";
      let latestPosition_id = "";
      for (let i = 0; i < this.positionHistories.length; i++) {
        this.positionHistories[i].change_date = dayjs(
          `${this.positionHistories[i].year}-${this.positionHistories[i].month}-${this.positionHistories[i].day}`
        ).format("YYYY-MM-DD");
        if (
          this.positionHistories[i].change_date > dayjs().format("YYYY-MM-DD")
        ) {
          this.errorInfo = "未来日付のデータが存在します。";
          return;
        }
        if (latestDate < this.positionHistories[i].change_date) {
          latestDate = this.positionHistories[i].change_date;
          latestPosition_id = this.positionHistories[i].position_id_after;
        }
      }
      if (this.user.position_id != latestPosition_id) {
        this.errorInfo =
          "最新の役職と社員に設定されている役職に相違があります。";
        return;
      }
      let data = this.positionHistories;
      let res = await this.$store
        .dispatch("FORCE_UPDATE_POSITION_HISTORY", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goPositionHistory();
      }
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goPositionHistory() {
      this.$router.push({
        path: `/position_history/${this.$route.params.user_id}`
      });
    },
    addPositionHistory() {
      let positionHistory = {
        year: "",
        month: "",
        day: "",
        user_id: this.$route.params.user_id,
        position_id_before: "",
        position_name_before: "",
        position_id_after: "",
        position_name_after: ""
      };
      this.positionHistories.push(positionHistory);
    },
    removePositionHistory: function(index) {
      this.positionHistories.splice(index, 1);
    },
    changePositionBefore(index) {
      let findPosition = this.positions.find(
        position =>
          position.id == this.positionHistories[index].position_id_before
      );
      this.positionHistories[index].position_name_before = findPosition.name;
    },
    changePositionAfter(index) {
      let findPosition = this.positions.find(
        position =>
          position.id == this.positionHistories[index].position_id_after
      );
      this.positionHistories[index].position_name_after = findPosition.name;
    }
  }
};
